export default __webpack_public_path__ + "static/media/about.4eaadd94.jpeg";